import { SoftSkillCategory, SoftSkillGranularity } from 'generated/graphql';
import {
  formatCategory,
  formatGranularity,
} from 'views/StaticContent/SoftSkills/SoftSkills.helpers';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

export const categorySelectOptions = [
  {
    label: formatCategory(SoftSkillCategory.RightForUs),
    value: SoftSkillCategory.RightForUs,
  },
  {
    label: formatCategory(SoftSkillCategory.RightForTheFuture),
    value: SoftSkillCategory.RightForTheFuture,
  },
  {
    label: formatCategory(SoftSkillCategory.CognitiveSummary),
    value: SoftSkillCategory.CognitiveSummary,
  },
  {
    label: formatCategory(SoftSkillCategory.RightForTheRole),
    value: SoftSkillCategory.RightForTheRole,
  },
];

export const granularitySelectOptions = [
  {
    label: formatGranularity(SoftSkillGranularity.Broad),
    value: SoftSkillGranularity.Broad,
  },
  {
    label: formatGranularity(SoftSkillGranularity.Focused),
    value: SoftSkillGranularity.Focused,
  },
];

export type SoftSkillFilters = {
  categoryFilter: SoftSkillCategory | null;
  granularityFilter: SoftSkillGranularity | null;
  taxonomyFilter: string | null;
};

export type FormValues = {
  category: TSelectOption<SoftSkillCategory | ''>;
  granularity: TSelectOption<SoftSkillGranularity | ''>;
  taxonomy: string;
};

export const emptyValues = {
  category: { label: '', value: '' },
  granularity: { label: '', value: '' },
  taxonomy: '',
} as const;

export const getFiltersCount = (formValues: FormValues) => {
  let count = 0;

  if (formValues.granularity.value) count += 1;
  if (formValues.category.value) count += 1;
  if (formValues.taxonomy) count += 1;

  return count;
};
